module.exports = __webpack_public_path__ + "static/media/categories_step_1_1.719a71c4.svg";